import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["image", "link", "placeholder"];

  connect() {
    if (this.hasImageTarget && this.imageTarget.complete && this.imageTarget.naturalWidth === 0) {
      this.unavailable();
    }
  }

  unavailable() {
    if (this.hasLinkTarget) this.linkTarget.classList.add("hidden");
    this.placeholderTarget.classList.remove("hidden");
  }
}
